import { Agent } from '@/types/agents'

export function getAgentTransactions(agent: Agent): {
  transactions: Record<string, number>
  localTransactions: number
  totalTransactions: number
} {
  const transactions = {
    single_family: 0,
    condominium: 0,
    townhome: 0
  }

  agent.transactions_summary.breakdown.forEach(type => {
    if (type.property_type in transactions) {
      transactions[type.property_type] = type.buy_count + type.sell_count
    }
  })

  return {
    transactions,
    totalTransactions: agent.transactions_summary.total,
    localTransactions: agent.transactions_summary.location_count,
  }
}
